import i18n from 'i18next';
import { initReactI18next, Trans } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { ReactElement } from 'react';

i18n.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: 'it',
		debug: false,
		interpolation: {
			escapeValue: false,
		},
		react: {
			useSuspense: true,
		},
	});

export function render(key: string): ReactElement {
	return <Trans
		i18nKey={key}
		components={{ strong: <strong /> }}
	/>;
}
